import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export default {
  namespaced: true,
  state: {
    active: false,
    dataCenter: null,
    apiKey: null,
    lang: null,
    loginApi: '',
    logoutApi: '',
    goTo: null,
    loaded: false,
    user: null,
    data: null,
    preferences: null,
    otActiveGroups: '',
    hashGuidApi: '',
    edit_profile_label: '',
    edit_privacy_label: '',
    home_page_url: '',
    logout_label: '',
    login_label: '',
    screensData: [],
    currentScreen: '',
    gigya_login_page_url: '',
    gigya_profile_page_url: '',
  },
  actions,
  mutations,
  getters,
};
